import {useAccountingDoorbell} from '../../hooks/useAccountingDoorbell';

interface AccountingDoorbellProps {
  businessCaseId: string;
  checkoutId: string;
  orderId: string;
}

/**
 * Headless carrier for `useAccountingDoorbell`.
 *
 * The external accounting refresh must not run at all for a tenant without the
 * `createExternalCheckoutDocuments` feature — no subscription filtering, no
 * requests, no timers. React forbids calling a hook conditionally, so the gate
 * has to be a mount boundary: rendering this component behind the permission is
 * what keeps the hook out of the tree entirely.
 */
export const AccountingDoorbell = (props: AccountingDoorbellProps) => {
  useAccountingDoorbell({
    businessCaseId: props.businessCaseId,
    checkoutId: props.checkoutId,
    orderId: props.orderId,
  });

  return null;
};
